"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bluebird_1 = __importDefault(require("bluebird"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const constants_1 = require("@powerednow/shared/constants");
const document_1 = require("@powerednow/shared/constants/document");
const textUtils_1 = __importDefault(require("@powerednow/shared/modules/utilities/textUtils"));
const date_1 = require("@powerednow/shared/modules/utilities/date");
const html_minifier_1 = require("html-minifier");
const audit_1 = __importDefault(require("@powerednow/shared/constants/audit"));
const decorators_1 = require("@powerednow/shared/modules/utilities/decorators");
const lodash_1 = require("lodash");
const fast_json_patch_1 = __importDefault(require("fast-json-patch"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const entity_1 = __importDefault(require("./entity"));
const modelLookup_1 = require("../modelLookup");
const renderData_1 = __importDefault(require("./renderData"));
const CONSTANTS = require('@powerednow/shared/constants').default;
const mathUtils = require('@powerednow/shared/modules/utilities/math');
// eslint-disable-next-line no-redeclare
class Document extends complexData_1.default {
    constructor() {
        super(...arguments);
        this.calculationData = {
            total: 0,
            vat: 0,
            cis_total: 0,
            cis_estimate: 0,
            cisable_amount: 0,
            subtotal: 0,
        };
    }
    static get allowedAssociations() {
        return {
            job: {
                key: 'job',
                instance: (0, modelLookup_1.complexFindModel)('Job'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().job_id,
                },
            },
            site: {
                key: 'contactToAddress',
                instance: (0, modelLookup_1.complexFindModel)('ContactToAddress'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().site_id,
                },
            },
            customer: {
                key: 'customer',
                instance: (0, modelLookup_1.complexFindModel)('Customer'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().customer_id,
                },
            },
            documentItem: {
                key: 'documentItem',
                instance: (0, modelLookup_1.complexFindModel)('DocumentItem'),
                cascadeDelete: true,
                condition: {
                    document_id: this.Entity.getFieldSymbols().id,
                },
            },
            customerRenderData: {
                key: 'documentContent',
                instance: (0, modelLookup_1.complexFindModel)('DocumentContent'),
                cascadeDelete: false,
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().customer_content_id,
                    type: constants_1.DOCUMENT.DOCUMENT_CONTENT_TYPE.CUSTOMER_DATA,
                },
            },
            companyRenderData: {
                key: 'documentContent',
                instance: (0, modelLookup_1.complexFindModel)('DocumentContent'),
                cascadeDelete: false,
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().company_content_id,
                    type: constants_1.DOCUMENT.DOCUMENT_CONTENT_TYPE.COMPANY_DATA,
                },
            },
            paymentToInvoice: {
                key: 'paymentToInvoice',
                instance: (0, modelLookup_1.complexFindModel)('PaymentToInvoice'),
                cascadeDelete: true,
                condition: {
                    document_id: this.Entity.getFieldSymbols().id,
                },
            },
            company: {
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                key: 'company',
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getFieldSymbols().company_id,
                },
            },
            message: {
                key: 'message',
                instance: (0, modelLookup_1.complexFindModel)('Message'),
                cascadeDelete: true,
                condition: {
                    document_id: this.Entity.getFieldSymbols().id,
                },
            },
            customerMessage: {
                key: 'customerMessage',
                instance: (0, modelLookup_1.complexFindModel)('CustomerMessage'),
                cascadeDelete: true,
                condition: {
                    linked_id: this.Entity.getFieldSymbols().id,
                    linked_type: CONSTANTS.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.DOCUMENT,
                },
            },
            relatedQuote: {
                key: 'documentToDocument',
                instance: (0, modelLookup_1.complexFindModel)('DocumentToDocument'),
                single: true,
                cascadeDelete: true,
                condition: {
                    child_document_id: this.Entity.getFieldSymbols().id,
                    type: document_1.DOCUMENT_TO_DOCUMENT_TYPES.INVOICE_TO_QUOTE,
                },
            },
            relatedInvoice: {
                key: 'documentToDocument',
                instance: (0, modelLookup_1.complexFindModel)('DocumentToDocument'),
                cascadeDelete: true,
                condition: {
                    parent_document_id: this.Entity.getFieldSymbols().id,
                    type: document_1.DOCUMENT_TO_DOCUMENT_TYPES.INVOICE_TO_QUOTE,
                },
            },
            relatedParentDocument: {
                key: 'documentToDocument',
                instance: (0, modelLookup_1.complexFindModel)('DocumentToDocument'),
                single: true,
                cascadeDelete: true,
                condition: {
                    child_document_id: this.Entity.getFieldSymbols().id,
                    type: document_1.DOCUMENT_TO_DOCUMENT_TYPES.PARENT_DOCUMENT,
                },
            },
            relatedChildDocument: {
                key: 'documentToDocument',
                instance: (0, modelLookup_1.complexFindModel)('DocumentToDocument'),
                cascadeDelete: true,
                condition: {
                    parent_document_id: this.Entity.getFieldSymbols().id,
                    type: document_1.DOCUMENT_TO_DOCUMENT_TYPES.PARENT_DOCUMENT,
                },
            },
            companyXeroIntegration: {
                key: 'companyIntegration',
                instance: (0, modelLookup_1.complexFindModel)('CompanyIntegration'),
                single: true,
                condition: {
                    integration_type_id: constants_1.INTEGRATION.INTEGRATION_TYPE.XERO,
                    company_id: this.Entity.getFieldSymbols().company_id,
                },
            },
            auditTrail: {
                key: 'auditTrail',
                instance: (0, modelLookup_1.complexFindModel)('AuditTrail'),
                condition: {
                    linked_id: this.Entity.getFieldSymbols().id,
                    linked_type: audit_1.default.LINK_TYPE.Document.code,
                },
            },
            user: {
                key: 'user',
                instance: (0, modelLookup_1.complexFindModel)('User'),
                single: true,
                condition: {
                    id: this.Entity.getFieldSymbols().user_id,
                },
            },
        };
    }
    static get indexedSearchConfig() {
        return {
            job: {},
            customerRenderData: true,
            companyRenderData: true,
            documentItem: true,
            user: true,
        };
    }
    static getStatusStringByTypeAndStatus(type, status) {
        const isExpense = type === constants_1.DOCUMENT.TYPES_VALUES.EXPENSE || type === CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE;
        const isSupplierInvoice = type === constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE;
        switch (status) {
            case constants_1.DOCUMENT.STATUS.RAISED:
                if (isExpense || isSupplierInvoice) {
                    return constants_1.DOCUMENT.STATUS_STRING.UNAPPROVED;
                }
                return constants_1.DOCUMENT.STATUS_STRING.RAISED;
            case constants_1.DOCUMENT.STATUS.SENT:
                if (type === constants_1.DOCUMENT.TYPES_VALUES.INVOICE) {
                    //
                    // In case of invoice "pending payment'
                    //
                    return constants_1.DOCUMENT.STATUS_STRING.PENDING_PAYMENT;
                }
                //
                // All other cases 'sent'
                //
                return constants_1.DOCUMENT.STATUS_STRING.QUOTE_SENT;
            case constants_1.DOCUMENT.STATUS.ACCEPTED:
                if (isExpense || isSupplierInvoice) {
                    return constants_1.DOCUMENT.STATUS_STRING.EXPENSE_ACCEPTED;
                }
                return constants_1.DOCUMENT.STATUS_STRING.ACCEPTED;
            case constants_1.DOCUMENT.STATUS.REJECTED:
                if (isExpense || isSupplierInvoice) {
                    return constants_1.DOCUMENT.STATUS_STRING.EXPENSE_REJECTED;
                }
                return constants_1.DOCUMENT.STATUS_STRING.REJECTED;
            case constants_1.DOCUMENT.STATUS.PAID:
                if (type === constants_1.DOCUMENT.TYPES_VALUES.CREDITNOTE) {
                    return constants_1.DOCUMENT.STATUS_STRING.RAISED;
                }
                return constants_1.DOCUMENT.STATUS_STRING.PAID;
            case constants_1.DOCUMENT.STATUS.PART_PAID:
                return constants_1.DOCUMENT.STATUS_STRING.PARTIALLY_PAID;
            case constants_1.DOCUMENT.STATUS.OVER_PAID:
                return constants_1.DOCUMENT.STATUS_STRING.OVER_PAID;
            default:
                return { promptId: '', defaultValue: '' };
        }
    }
    getStatusStringPrompt() {
        return Document.getStatusStringByTypeAndStatus(this.data.type, this.data.status);
    }
    getDocumentGroupTypeId() {
        const documentGroupTypes = CONSTANTS.DOCUMENT.DOCUMENT_GROUP_TYPE;
        return documentGroupTypes[this.data.type];
    }
    getDocumentPaymentCategory() {
        return CONSTANTS.DOCUMENT.DOCUMENT_TYPE_TO_DOCUMENT_PAYMENT_CATEGORY[this.data.type];
    }
    async getDefaultSite() {
        const customer = await this.getCustomer();
        switch (this.data.type) {
            case CONSTANTS.DOCUMENT.TYPES_VALUES.INVOICE:
            case CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE:
            case CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT:
                return (await customer.getInvoiceSite()) || customer.getMainSite();
            case CONSTANTS.DOCUMENT.TYPES_VALUES.QUOTE:
            case CONSTANTS.DOCUMENT.TYPES_VALUES.WORKSHEET:
            case CONSTANTS.DOCUMENT.TYPES_VALUES.SIGNATURE:
            case CONSTANTS.DOCUMENT.TYPES_VALUES.CREDITNOTE:
            case CONSTANTS.DOCUMENT.TYPES_VALUES.EXPENSE:
            case CONSTANTS.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE:
            case CONSTANTS.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER:
                return customer.getMainSite();
            default:
                return null;
        }
    }
    /**
     * Return the name appearing on the invoice what is the company name if specified otherwise the
     * customer name
     */
    async getInvoiceName() {
        const customerObject = await this.getCustomer();
        return customerObject.getFullName(false, true);
    }
    async recordPayment(paymentValues, cisAmount = 0, creditNoteId = null) {
        let complexCisPayment;
        if (cisAmount && cisAmount !== 0) {
            complexCisPayment = await this.createPayment({
                ...paymentValues,
                amount: cisAmount,
                is_cis: true,
                type: CONSTANTS.PAYMENT.TYPES.CIS,
            }, creditNoteId);
        }
        const complexPayment = await this.createPayment({
            ...paymentValues,
            cis_payment_id: complexCisPayment ? complexCisPayment.data.id : null,
        }, creditNoteId);
        const jobInstance = await this.getJob();
        if (this.data.accounting_reference === constants_1.INTEGRATION.ACCOUNTING_REFERENCE_NO_SYNC) {
            complexPayment.data.accounting_reference = constants_1.INTEGRATION.ACCOUNTING_REFERENCE_NO_SYNC;
        }
        await jobInstance.addPayment(complexPayment);
        await jobInstance.updateTotals();
        await this.setStatus();
        return {
            complexPayment,
            complexCisPayment,
        };
    }
    async createPayment(paymentValues, creditNoteId = null) {
        const paymentToInvoice = await this.addPaymentToInvoice({
            amount: paymentValues.amount,
            credit_note_id: creditNoteId,
        });
        return paymentToInvoice.setPayment(paymentValues);
    }
    async hasPaymentWithType(paymentTypeId) {
        return (await this.getPayments()).some(payment => payment.data.type === paymentTypeId);
    }
    async getPayments() {
        const paymentTypes = await (0, modelLookup_1.complexFindModel)('PaymentType').getAll(this);
        return bluebird_1.default.reduce(this.getAllPaymentToInvoice(), async (paymentItems, paymentToInvoice) => {
            const complexPayment = await paymentToInvoice.getPayment();
            //
            // Some cases we may have paymentToInvoce record but not Payment record
            // We should not crash in that case
            //
            if (complexPayment) {
                complexPayment.displayTypeString = paymentTypes.find(type => type.data.id === complexPayment.data.type).data.name;
                paymentItems.push(complexPayment);
            }
            return paymentItems;
        }, []);
    }
    async getAlreadyInvoicedAmount() {
        const allDocumentToDocument = await this.getAllRelatedInvoice();
        const invoices = await bluebird_1.default.map(allDocumentToDocument, invToQuote => invToQuote.getChild());
        const filteredInvoices = invoices.filter(invoice => {
            if (!invoice) {
                return false;
            }
            return !invoice.data.isdeleted;
        });
        return bluebird_1.default.reduce(filteredInvoices, async (acc, invoice) => acc + (await invoice.getOutstandingAmount()).outstanding + (await invoice.getAlreadyPaidAmount()).alreadyPaid, 0);
    }
    async isQuoteFullyInvoiced() {
        const invoicedAmounts = await this.getAlreadyInvoicedAmount();
        return this.data.total <= invoicedAmounts;
    }
    async getParentDocument() {
        const parent = await this.getRelatedParentDocument();
        return parent?.getParent();
    }
    async isDisbursement() {
        const parentDoc = await this.getParentDocument();
        return this.data.is_disbursement && parentDoc;
    }
    async addParentDisplayNumberDescription(parentDocument) {
        const documentItem = await this.addDocumentItem({
            sequence: 9999,
        });
        await documentItem.setNote({
            title: 'Generated from:',
            description: parentDocument.data.displaynumber,
            job_id: this.data.job_id,
            is_hidden: true,
        });
    }
    async setParent(parentDocument) {
        const company = await this.getCompany();
        const partInvoicingEnabled = await company.getParsedSettingValue(constants_1.SETTINGS_KEYS.PART_INVOICING_FROM_QUOTES_ENABLED);
        if (partInvoicingEnabled && parentDocument.data.type === document_1.TYPES_VALUES.QUOTE) {
            const includeQuoteNumberInDescription = await company.getParsedSettingValue(constants_1.SETTINGS_KEYS.INCLUDE_QUOTE_NUMBER_IN_DESCRIPTION_LINES);
            if (includeQuoteNumberInDescription) {
                await this.addParentDisplayNumberDescription(parentDocument);
            }
            const quoteFullyInvoiced = await parentDocument.isQuoteFullyInvoiced();
            if (!quoteFullyInvoiced) {
                await parentDocument.addRelatedInvoice({
                    child_document_id: this.data.id,
                    company_id: company.data.id,
                    type: document_1.DOCUMENT_TO_DOCUMENT_TYPES.INVOICE_TO_QUOTE,
                });
            }
        }
        else {
            await this.setRelatedParentDocument({
                parent_document_id: parentDocument.data.id,
                company_id: company.data.id,
                type: document_1.DOCUMENT_TO_DOCUMENT_TYPES.PARENT_DOCUMENT,
            });
        }
    }
    async getAlreadyPaidAmount(excludeRecords = []) {
        let alreadyPaid = 0;
        let alreadyPaidCIS = 0;
        let alreadyPaidAmount = 0;
        (await this.getPayments())
            .filter(filterRec => excludeRecords.every(record => record.data.id !== filterRec.data.id))
            .forEach(paymentRec => {
            if (paymentRec.data.type === CONSTANTS.PAYMENT.TYPES.CIS) {
                alreadyPaidCIS += paymentRec.data.amount;
            }
            else {
                alreadyPaidAmount += paymentRec.data.amount;
            }
            alreadyPaid += paymentRec.data.amount;
        });
        //
        // reverse if expense
        //
        if (this.data.type === CONSTANTS.DOCUMENT.TYPES_VALUES.EXPENSE || this.data.type === CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE) {
            alreadyPaid = -alreadyPaid;
            alreadyPaidCIS = -alreadyPaidCIS;
            alreadyPaidAmount = -alreadyPaidAmount;
        }
        return {
            alreadyPaid,
            alreadyPaidCIS,
            alreadyPaidAmount,
        };
    }
    async getOutstandingAmount() {
        const documentTotal = mathUtils.roundPrice(this.data.total);
        const creditedTotal = await this.getTotalCredited();
        const cisTotal = mathUtils.roundPrice(this.data.cis_total);
        const paidValues = await this.getAlreadyPaidAmount();
        const outstanding = mathUtils.roundPrice(documentTotal + creditedTotal - paidValues.alreadyPaid);
        const outstandingCIS = mathUtils.roundPrice(cisTotal - paidValues.alreadyPaidCIS);
        const outstandingAmount = mathUtils.roundPrice(outstanding - outstandingCIS);
        return {
            outstanding,
            outstandingCIS,
            outstandingAmount,
        };
    }
    async getTotalPaid() {
        return bluebird_1.default.reduce(this.getPayments(), (currentTotal, paymentItem) => (paymentItem ? currentTotal + paymentItem.data.amount : currentTotal), 0);
    }
    async getCreditNotes() {
        const documents = await this.getAllChildDocument();
        return documents.filter(document => document?.isOneOfCreditNotes());
    }
    async getAllChildDocument() {
        /*
        * The `getAllRelatedChildDocument` returns `DocumentToDocument` entities, so we need to call
        * `.getChild()` to have the `Document` entity.
        * */
        return bluebird_1.default.map(this.getAllRelatedChildDocument(), item => item.getChild());
    }
    async getSalesDisbursement() {
        const docToDoc = await this.getRelatedChildDocument(0);
        return docToDoc?.getChild();
    }
    async getChildrenByFilterFn(fn) {
        const items = await this.getAllChildDocument();
        return items.filter(Boolean).filter(fn);
    }
    async getChildrenByType(type) {
        const types = Array.isArray(type) ? type : [type];
        return this.getChildrenByFilterFn(document => types.includes(document.data.type));
    }
    async getAllInvoiceOrSupplierInvoiceCreditChild() {
        return this.getChildrenByType([document_1.TYPES_VALUES.INVOICE, document_1.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT]);
    }
    getTotalCredited() {
        return bluebird_1.default.reduce(this.getCreditNotes(), (currentTotal, documentItem) => currentTotal + documentItem.data.total, 0);
    }
    async getTotals() {
        const totalPaid = await this.getTotalPaid();
        const totalCredited = await this.getTotalCredited();
        const totalPayable = (this.data.total + totalCredited) * (this.isCost() ? -1 : 1);
        const allPayments = await this.getPayments();
        return {
            totalPayable: Math.round(totalPayable * 100) / 100,
            totalPaid: Math.round(totalPaid * 100) / 100,
            totalCredited: Math.round(totalCredited * 100) / 100,
            hasPayment: allPayments && allPayments.length > 0,
        };
    }
    async getPaymentsOfSameType(paymentItem) {
        const siblingPayments = await this.getPayments();
        return siblingPayments.filter(payment => payment.data.type === paymentItem.data.type);
    }
    async isRefundedPayment(paymentItem) {
        const sameTypePayments = await this.getPaymentsOfSameType(paymentItem);
        return sameTypePayments.some(payment => payment.data.is_refund && payment.data.reference === paymentItem.data.reference);
    }
    isCost() {
        return (this.data.type === CONSTANTS.DOCUMENT.TYPES_VALUES.EXPENSE
            || this.data.type === CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE);
    }
    async setStatus(previousStatus = null, hadPayment = false, hadCreditNote = false) {
        const { totalPayable, totalPaid, totalCredited, hasPayment, } = await this.getTotals();
        const absTotalPayable = Math.abs(totalPayable);
        const absTotalPaid = Math.abs(totalPaid);
        if (this.data.type === CONSTANTS.DOCUMENT.TYPES_VALUES.CREDITNOTE) { // processed credit notes are always paid.
            this.data.status = CONSTANTS.DOCUMENT.STATUS.PAID;
        }
        if (!hasPayment && !hadPayment && totalCredited === 0 && !hadCreditNote) {
            return;
        }
        if (absTotalPayable === absTotalPaid) {
            this.data.status = CONSTANTS.DOCUMENT.STATUS.PAID;
        }
        else if (absTotalPayable > absTotalPaid) {
            if (mathUtils.nearlyEqual(absTotalPaid, 0) && totalCredited === 0) {
                if (this.isCost()) {
                    if (previousStatus !== null) {
                        this.data.status = previousStatus;
                    }
                    else {
                        this.data.status = CONSTANTS.DOCUMENT.STATUS.ACCEPTED;
                    }
                }
                else {
                    this.data.status = CONSTANTS.DOCUMENT.STATUS.RAISED;
                }
            }
            else {
                this.data.status = CONSTANTS.DOCUMENT.STATUS.PART_PAID;
            }
        }
        else {
            this.data.status = CONSTANTS.DOCUMENT.STATUS.OVER_PAID;
        }
    }
    /**
     * tells if document is one of the creditnote type
     *
     * @returns {boolean}
     */
    isOneOfCreditNotes() {
        const { data } = this;
        return CONSTANTS.DOCUMENT.CREDIT_NOTE_TYPES.includes(data.type);
    }
    isQuote() {
        const { data } = this;
        return data.type === CONSTANTS.DOCUMENT.TYPES_VALUES.QUOTE;
    }
    isJobSheet() {
        const { data } = this;
        return data.type === CONSTANTS.DOCUMENT.TYPES_VALUES.WORKSHEET;
    }
    shouldHidePaymentButton() {
        return this.isQuote()
            || this.isPurchaseOrder()
            || this.isJobSheet();
    }
    async getInvoiceTotals() {
        const prefixAndSeparator = [CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE,
            CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT].includes(this.data.type) ? 'supplier_' : '';
        return {
            [`${prefixAndSeparator}invoiced`]: mathUtils.roundPrice(this.data.total),
            [`${prefixAndSeparator}invoiced_exVat`]: mathUtils.roundPrice((this.data.total === this.data.subtotal) ? this.data.total - this.data.vat : this.data.subtotal),
            [`${prefixAndSeparator}invoice_payments`]: mathUtils.roundPrice(await this.getTotalPaid()),
        };
    }
    async getQuoteTotals() {
        return {
            quoted: mathUtils.roundPrice(this.data.total),
            accepted: mathUtils.roundPrice(this.data.accepted),
        };
    }
    async getDocumentTotals() {
        const getTotalFunction = {
            [CONSTANTS.DOCUMENT.TYPES_VALUES.INVOICE]: this.getInvoiceTotals.bind(this),
            [CONSTANTS.DOCUMENT.TYPES_VALUES.CREDITNOTE]: this.getInvoiceTotals.bind(this),
            [CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE]: this.getInvoiceTotals.bind(this),
            [CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT]: this.getInvoiceTotals.bind(this),
            [CONSTANTS.DOCUMENT.TYPES_VALUES.QUOTE]: this.getQuoteTotals.bind(this),
        }[this.data.type];
        return getTotalFunction ? getTotalFunction() : {};
    }
    async paymentCanBeRecorded(paymentTypeId, isRefund, isInitiatedByUser = false) {
        if (this.data.isdeleted) {
            return false;
        }
        const documentPaymentCategory = this.getDocumentPaymentCategory();
        if (!documentPaymentCategory) {
            return false;
        }
        const company = await this.getCompany();
        const documentType = this.data.type;
        const countryId = await ((0, modelLookup_1.complexFindModel)('Company')).getCompanyCountryId(this);
        const paymentSetting = await company.getPaymentSettingByPaymentTypeId(paymentTypeId);
        const isPaid = await this.isPaid();
        if (!paymentSetting || !(await paymentSetting.isEnabledForDocumentPaymentCategory(documentPaymentCategory))) {
            return false;
        }
        const totalOverAvailabilityLimit = paymentSetting.data.availability_limit_enabled && paymentSetting.data.availability_limit <= this.data.total;
        const paymentType = await paymentSetting.getPaymentType();
        if (!await paymentType.isValidForCountry(countryId)) {
            return false;
        }
        if (!await paymentType.enabledForDocumentType(this.data.type)) {
            return false;
        }
        if (paymentTypeId === CONSTANTS.PAYMENT.TYPES.PAYPAL_STANDARD) {
            if (!isRefund && (isPaid || documentType !== CONSTANTS.DOCUMENT.TYPES_VALUES.INVOICE)) {
                return false;
            }
        }
        if (paymentTypeId === CONSTANTS.PAYMENT.TYPES.SUMUP) {
            if (totalOverAvailabilityLimit) {
                return false;
            }
            if (!isRefund && (isPaid || documentType !== CONSTANTS.DOCUMENT.TYPES_VALUES.INVOICE)) {
                return false;
            }
            if (isRefund && !await this.hasPaymentWithType(CONSTANTS.PAYMENT.TYPES.SUMUP)) {
                return false;
            }
        }
        if (paymentTypeId === CONSTANTS.PAYMENT.TYPES.SUMUP_ONLINE) {
            if (totalOverAvailabilityLimit) {
                return false;
            }
            if (!isRefund && !isInitiatedByUser) {
                return false;
            }
            if (!isRefund && (isPaid || documentType !== CONSTANTS.DOCUMENT.TYPES_VALUES.INVOICE)) {
                return false;
            }
            if (isRefund && !await this.hasPaymentWithType(CONSTANTS.PAYMENT.TYPES.SUMUP_ONLINE)) {
                return false;
            }
        }
        return true;
    }
    async isPaid() {
        const documentStatus = this.data.status;
        const outstandingAmount = await this.getOutstandingAmount();
        return [CONSTANTS.DOCUMENT.STATUS.PAID, CONSTANTS.DOCUMENT.STATUS.OVER_PAID].includes(documentStatus) || outstandingAmount.outstandingAmount <= 0;
    }
    async getPaymentTitleText() {
        const customerName = await this.getInvoiceName();
        return this.data.displaynumber === CONSTANTS.DOCUMENT.DEFAULT_DISPLAY_NUMBER ? customerName : `${customerName} - ${this.data.displaynumber}`;
    }
    /**
     * Execute all calculations and update data
     *
     * @returns {*|{}}
     */
    async calculate() {
        this.resetCalculatedFields();
        await bluebird_1.default.each(this.getPricedItems(), item => this.recalculatePricedItem(item));
        this.roundTotals();
        this.emit(CONSTANTS.BUSINESS_CALCULATOR.EVENTS.DOCUMENT_RECALCULATED, this.getData());
        this.data.total = this.calculationData.total;
        this.data.vat = this.calculationData.vat;
        this.data.cis_total = this.calculationData.cis_total;
        this.data.cis_estimate = this.calculationData.cis_estimate;
        this.data.cisable_amount = this.calculationData.cisable_amount;
        this.data.subtotal = this.calculationData.subtotal;
        return this.getData();
    }
    isApproved() {
        const DOC_STATUES = CONSTANTS.DOCUMENT.STATUS;
        return ![
            DOC_STATUES.REJECTED,
            DOC_STATUES.RAISED,
        ].includes(this.data.status);
    }
    async getFilteredDocumentItems(type) {
        const documentItems = await this.getAllDocumentItem();
        if (!type) {
            return documentItems;
        }
        return documentItems.filter(documentItem => documentItem.data.type === type);
    }
    async getJobItemGroups(type) {
        const filteredDocumentItems = await this.getFilteredDocumentItems(type);
        const jobItemGroups = await bluebird_1.default.map(filteredDocumentItems, filteredDocumentItem => filteredDocumentItem.getJobItemGroup()).filter(Boolean);
        return jobItemGroups;
    }
    async getJobItems() {
        const jobItemGroups = await this.getJobItemGroups();
        return bluebird_1.default.reduce(jobItemGroups, async (jobItems, jobItemGroup) => [...jobItems, ...(await jobItemGroup.getAllJobItem())], []);
    }
    async isSigned() {
        const documentItems = await this.getAllDocumentItem();
        const signatures = documentItems.filter(item => item.data.type === 'Signature');
        return Boolean(signatures.length);
    }
    async isMixedTax(options = {}) {
        const totalsByVatId = await this.getTotalsByVatId(options);
        return (Object.keys(totalsByVatId).length > 1);
    }
    async getCustomerMessageRecipients() {
        const customerMessageComplex = (0, modelLookup_1.complexFindModel)('CustomerMessage');
        return customerMessageComplex.getCustomerMessageRecipients(this);
    }
    async getMessages() {
        return (await this.getAllMessage()).filter(item => item.data.type === CONSTANTS.MESSAGES.MESSAGE_TYPES.DOCUMENT.ID);
    }
    async getBannerItems() {
        const auditTrailItems = await this.getAuditTrails();
        const filteredAuditTrailItems = auditTrailItems
            .filter(item => item.event_type === audit_1.default.LINK_TYPE.Document.event_type.DOC_PRINTED
            || item.event_type === audit_1.default.LINK_TYPE.Document.event_type.RECEIPT_SENT
            || item.event_type === audit_1.default.LINK_TYPE.Document.event_type.CHASING_DISABLED
            || item.event_type === audit_1.default.LINK_TYPE.Document.event_type.CHASING_ENABLED)
            .map(data => ({ type: 'trailItem', data }));
        const items = [
            ...await this.getPayments(),
            ...await this.getCustomerMessageRecipients(),
            ...await this.getMessages(),
            ...filteredAuditTrailItems,
        ];
        items.sort((a, b) => a.data.dt_created.localeCompare(b.data.dt_created));
        return items;
    }
    async getAuditTrails() {
        const auditTrails = await this.getAllAuditTrail();
        return bluebird_1.default.map(auditTrails, async (auditTrail) => {
            // @ts-ignore
            const user = await auditTrail.getUser();
            return {
                ...auditTrail.data.getPureDataValues(),
                user_name: (user && !user.data.isdeleted) ? user.getFullName() : 'User.deletedUserLabel',
            };
        });
    }
    async delete() {
        /**
         * This may seem counterintuitive, but here is the reasoning:
         * If we delete the document and the credit notes _after_, then on other clients the credit notes and credit note payments
         * can appear broken, as their parent document is removed(and the sync is paused, or whatever)
         *
         * So let's remove the children first, nothing appears broken, even in a stopped sync, then remove the document.
         */
        const creditNotes = await this.getCreditNotes();
        await bluebird_1.default.each(creditNotes, async (creditNote) => creditNote.delete());
        await super.delete();
        return null;
    }
    async getDisplayedAuditTrails() {
        const auditTrailItems = await this.getAuditTrails();
        const filteredAuditTrailItems = auditTrailItems
            .filter(auditTrailItem => auditTrailItem.event_type !== audit_1.default.LINK_TYPE.Document.event_type.DOC_PRINTED
            && auditTrailItem.event_type !== audit_1.default.LINK_TYPE.Document.event_type.RECEIPT_SENT
            && auditTrailItem.event_type !== audit_1.default.LINK_TYPE.Document.event_type.CHASING_DISABLED
            && auditTrailItem.event_type !== audit_1.default.LINK_TYPE.Document.event_type.CHASING_ENABLED);
        filteredAuditTrailItems.sort((a, b) => a.dt_created.localeCompare(b.dt_created));
        return filteredAuditTrailItems;
    }
    async getBannerData(L) {
        const items = await this.getBannerItems();
        const related = await this.getAllChildDocument();
        const payments = await this.getPayments();
        const job = await this.getJob();
        const auditTrails = await this.getDisplayedAuditTrails();
        const parentDoc = await this.getParentDocument();
        let parentDocDisplayName = '';
        if (parentDoc) {
            const renderData = await parentDoc.getDocumentRenderData(L, { isPreview: false, fullName: '' });
            parentDocDisplayName = renderData.typeString;
        }
        const doc = this;
        const docRenderData = await doc.getDocumentRenderData(L, { isPreview: false, fullName: '' });
        const docDisplayName = docRenderData.typeString;
        return {
            items,
            related,
            doc,
            docDisplayName,
            payments,
            job,
            auditTrails,
            parentDoc,
            parentDocDisplayName,
        };
    }
    async isTaxInclusiveExpense() {
        let taxInclExp = false;
        if (this.isExpense()) {
            taxInclExp = await this.isInclusive();
        }
        return taxInclExp;
    }
    getFormattedNumber() {
        return this.data.displaynumber;
    }
    async getDefaultPaymentType() {
        const company = await this.getCompany();
        let lookupKey;
        switch (this.data.type) {
            case CONSTANTS.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE:
                lookupKey = 'supplier_payment_id';
                break;
            case CONSTANTS.DOCUMENT.TYPES_VALUES.EXPENSE:
                lookupKey = 'expense_payment_id';
                break;
            default:
                lookupKey = 'sales_payment_id';
        }
        const defaultLayoutValues = company.constructor.Entity.fields.find(item => item.name === 'default_payment_type_ids')?.defaultValue;
        const values = { ...defaultLayoutValues, ...company.data.default_payment_type_ids };
        const paymentTypes = await (0, modelLookup_1.complexFindModel)('PaymentType').getAll(this);
        return paymentTypes.find(item => item.data.id === values[lookupKey]);
    }
    async isLocked() {
        const company = await this.getCompany();
        const lockDates = await company.getAllLockDate();
        if (!lockDates.length) {
            return false;
        }
        const lastLockDate = lockDates[lockDates.length - 1];
        return (0, date_1.dateDifference)(this.data.taxpoint || this.data.dt_created, lastLockDate.data.lockDate) >= 0;
    }
    async calculateCredit(options) {
        await this.calculate();
        const totalsByVatId = await this.getTotalsByVatId(options);
        const isMixed = await this.isMixedTax(options);
        const isInclusive = await this.isInclusive();
        const creditAmount = await this.calculateCreditAmount(options);
        const lines = {};
        let taxRate = 0;
        if (await this.isTaxUsed()) {
            taxRate = mathUtils.getTaxRateByCost(isInclusive ? this.data.total : this.data.subtotal, this.data.vat, isInclusive);
            if (!options.prorate && isMixed) {
                taxRate = options.tax_rate;
            }
        }
        let vat;
        let total;
        let amount;
        if (options.is_inclusive) {
            vat = mathUtils.calculateIncludedTax(creditAmount, taxRate);
            total = creditAmount;
            amount = creditAmount - vat;
        }
        else {
            vat = mathUtils.calculateTax(creditAmount, taxRate);
            total = creditAmount + vat;
            amount = creditAmount;
        }
        // mixed and use pro-rate tax
        // (its mixed but all lines would like to keep own tax rate)
        //
        if (options.prorate && isMixed) {
            Object.keys(totalsByVatId).forEach(key => {
                const value = totalsByVatId[key];
                const rate = creditAmount / this.getData().total;
                lines[key] = {
                    subtotal: value.subtotal * rate,
                    total: value.total * rate,
                    vat: value.vat * rate,
                    rate: value.rate,
                    name: value.name,
                };
            });
            //
            // mixed/not mixed and used pro-rate (one rate for all items)
            //
        }
        else {
            // use selected rate id if not prorate
            let nonMixedId;
            if (!options.prorate) {
                nonMixedId = options.vat_id;
            }
            else {
                [nonMixedId] = Object.keys(totalsByVatId);
            }
            lines[nonMixedId] = {
                subtotal: amount,
                vat,
                total,
                rate: options.tax_rate,
                name: options.tax_name,
            };
        }
        return {
            amount,
            vat,
            total,
            refusereason: options.refusereason,
            lines,
            nTotal: total,
        };
    }
    async recalculatePricedItem(item) {
        const priceMode = this.getDocumentGroupTypeId() === constants_1.DOCUMENT.DOCUMENT_GROUP_TYPE_ID.SUPPLIER ? 'cost_price' : 'sales_price';
        const newData = await item.calculate({
            cloneData: false,
            use_tax: item.data.vat_registered,
            is_inclusive: item.data.tax_inclusive,
            cisEnabled: this.data.is_cis,
            priceMode,
        });
        this.updateTotals(newData);
        return newData;
    }
    /**
     * Add the line totals to the document totals
     *
     * @param item
     * @private
     */
    updateTotals(item) {
        const subtotal = item.subtotal + (item.discount === null ? 0 : item.discount);
        //
        // If document type is quote and display total flag is off then
        // use the max value in the totals
        //
        if (!this.data.display_total && this.data.type === 1) {
            this.calculationData.total = Math.max(this.calculationData.total, item.total);
            this.calculationData.vat = Math.max(this.calculationData.vat, item.vat);
            this.calculationData.cis_total = item.cis_total;
            this.calculationData.cis_estimate = item.cis_estimate;
            this.calculationData.cisable_amount = item.cisable_amount;
            this.calculationData.subtotal = Math.max(this.calculationData.subtotal, subtotal);
        }
        else {
            //
            // Otherwise just accumulate values
            //
            this.calculationData.total += item.total;
            this.calculationData.vat += item.vat;
            this.calculationData.cis_total += item.cis_total;
            this.calculationData.cis_estimate += item.cis_estimate;
            this.calculationData.cisable_amount += item.cisable_amount;
            this.calculationData.subtotal += subtotal;
        }
    }
    async getPricedItems() {
        const items = (await this.getAllDocumentItem()).filter(item => item.data.linked_id && item.data.type === CONSTANTS.DOCUMENT.DOCUMENT_ITEMS.TYPES.JOB_ITEM_GROUP);
        return bluebird_1.default.map(items, item => item.getLinkedItem()).filter(Boolean);
    }
    /**
     * Checks whether the priced items in the document are taxed
     *
     * @returns {boolean}
     * @private
     */
    async isTaxUsed() {
        let taxUsed = false;
        (await this.getPricedItems()).forEach(item => {
            taxUsed = taxUsed || item.data.vat_registered;
        });
        return taxUsed;
    }
    /**
     * Checks whether the pricet items included in the document are tax inclusive
     *
     * @returns {boolean}
     * @private
     */
    async isInclusive() {
        let isInclusive = false;
        (await this.getPricedItems()).forEach(item => {
            isInclusive = isInclusive || item.data.tax_inclusive;
        });
        return isInclusive;
    }
    async calculateCreditAmount(values) {
        let originalAmount;
        if (values.amount_type === 0) {
            originalAmount = (this.getData().total / 100) * values.value;
            if (await this.isTaxUsed() && !(await this.isInclusive()) && (values.is_inclusive === 0)) {
                originalAmount = (this.getData().subtotal / 100) * values.value;
            }
        }
        else {
            originalAmount = values.value;
        }
        return originalAmount;
    }
    /**
     * Collect priced item lines grouped by VAT rate
     *
     * @param options
     * @returns {{}}
     * @private
     */
    async getTotalsByVatId(options = {}) {
        const vatIds = [];
        const totalsByVatId = {};
        await bluebird_1.default.each(this.getPricedItems(), async (item) => {
            const discountBase = options.is_inclusive ? item.data.subtotal : item.data.total;
            const discountRate = (discountBase + item.data.discount) / discountBase;
            await bluebird_1.default.each(await item.getAllJobItem(), async (line) => {
                const data = line.getData();
                const subtotal = (data.is_inclusive
                    ? data.cost
                    : data.cost - data.vat) * discountRate;
                const total = data.cost * discountRate;
                if (!vatIds.includes(data.vat_id)) {
                    vatIds.push(data.vat_id);
                    totalsByVatId[data.vat_id] = {
                        subtotal,
                        total,
                        vat: data.vat * discountRate,
                        name: data.tax_name,
                        rate: data.vat_rate,
                    };
                }
                else {
                    totalsByVatId[data.vat_id].subtotal += subtotal;
                    totalsByVatId[data.vat_id].total += total;
                    totalsByVatId[data.vat_id].vat += data.vat * discountRate;
                }
            });
        });
        return totalsByVatId;
    }
    /**
     * Reset all calculated values. Used to start new calculations
     * with clean sheets.
     *
     * @private
     */
    resetCalculatedFields() {
        this.calculationData = {
            total: 0,
            vat: 0,
            cis_total: 0,
            cis_estimate: 0,
            cisable_amount: 0,
            subtotal: 0,
        };
    }
    roundTotals() {
        this.calculationData.total = mathUtils.roundPrice(this.calculationData.total);
        this.calculationData.vat = mathUtils.roundPrice(this.calculationData.vat);
        this.calculationData.subtotal = mathUtils.roundPrice(this.calculationData.subtotal);
    }
    async findJobSite() {
        const job = await this.getJob();
        return job.findSite();
    }
    async findSite() {
        const site = await this.getSite();
        if (site) {
            return site;
        }
        const job = await this.getJob();
        return job.findSite();
    }
    async getMessageTemplateData(messageType) {
        return this.data.getPureDataValues();
    }
    async getPermanentTemplateData() {
        return {};
    }
    async getSummaryData() {
        const summaryObject = {};
        const docTypeName = constants_1.DOCUMENT.TYPES[this.data.type];
        const pricedItemGroups = await this.getPricedItems();
        if (!pricedItemGroups.length) {
            return summaryObject;
        }
        const { showTotal, showGroupTitles, showItems, showItemDescriptions, } = this.parsePricedItemLayout(docTypeName, pricedItemGroups[0].data[`priced_item_${docTypeName}_layout`]);
        summaryObject.showTotal = showTotal;
        if (!showGroupTitles && !showItems) {
            return summaryObject;
        }
        summaryObject.groupTitles = [];
        summaryObject.itemDescriptions = [];
        await bluebird_1.default.each(pricedItemGroups, async (pricedItemGroup) => {
            summaryObject.groupTitles.push(showGroupTitles ? pricedItemGroup.data.title : '');
            if (showItems) {
                const pricedItems = await pricedItemGroup.getAllJobItem();
                const itemDescriptions = showItemDescriptions ? pricedItems.map(item => item.data.description) : [`${pricedItems.length} items`];
                summaryObject.itemDescriptions.push(itemDescriptions);
            }
        });
        return summaryObject;
    }
    async updateSummary() {
        this.data.summary = await this.getDocumentSummary();
    }
    async getDocumentSummary() {
        const pricedItemGroups = await this.getPricedItems();
        if (!pricedItemGroups.length) {
            return 'N/A';
        }
        const company = await this.getCompany();
        const currency = await company.getCurrency();
        return bluebird_1.default.reduce(pricedItemGroups, async (summary, pricedItemGroup) => {
            let documentSummary = summary + (pricedItemGroup.data.title ? `<h2 class="details-title">${(pricedItemGroup.data.title)}</h2>` : '');
            const pricedItems = await pricedItemGroup.getAllJobItem();
            let itemTable = '<table style="width:100%">';
            (await pricedItemGroup.getAllJobItem()).forEach(item => {
                itemTable += '<tr>';
                itemTable += `<td>${item.data.description}</td>`;
                itemTable += this.data.display_total ? `<td style="text-align: right">${textUtils_1.default.formatMoney(item.data.cost, currency.data)}</td>` : '';
                itemTable += '</tr>';
            });
            itemTable += '</table>';
            documentSummary += itemTable;
            return documentSummary;
        }, '');
    }
    parsePricedItemLayout(docTypeName, layoutSettings) {
        return {
            showGroupTitles: layoutSettings[`${docTypeName}_show_title`],
            showItems: layoutSettings[`${docTypeName}_show_line`],
            showItemDescriptions: layoutSettings[`${docTypeName}_show_line_description`],
            showTotal: layoutSettings[`${docTypeName}_show_total`],
        };
    }
    isPurchaseOrder() {
        return this.data.type === CONSTANTS.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER;
    }
    getDocTypeTitle() {
        const docTypeValues = CONSTANTS.DOCUMENT.TYPES_VALUES;
        const isDisbursement = this.data.is_disbursement;
        const isSalesDisbursement = isDisbursement && docTypeValues.INVOICE === this.data.type;
        const isSupplierDisbursement = isDisbursement && docTypeValues.SUPPLIER_INVOICE === this.data.type;
        const typeTimeLineTitleMap = {
            [docTypeValues.INVOICE]: isSalesDisbursement ? 'JobScreen.SalesDisbursementTitle' : 'JobScreen.InvoiceTitle',
            [docTypeValues.QUOTE]: 'JobScreen.QuoteTitle',
            [docTypeValues.WORKSHEET]: 'JobScreen.WorksheetTitle',
            [docTypeValues.CREDITNOTE]: 'JobScreen.CreditnoteTitle',
            [docTypeValues.SIGNATURE]: 'JobScreen.SignatureTitle',
            [docTypeValues.SUPPLIER_INVOICE]: isSupplierDisbursement ? 'JobScreen.CostDisbursementTitle' : 'JobScreen.ExpenseSupplierInvoiceTitle',
            [docTypeValues.EXPENSE]: 'JobScreen.ExpenseTitle',
            [docTypeValues.SUPPLIER_INVOICE_CREDIT]: 'JobScreen.SupplierInvoiceCreditNoteTitle',
            [docTypeValues.EXPENSE_CREDITNOTE]: isDisbursement ? 'JobScreen.CostDisbursementTitle' : 'ExpenseCreditNoteTitle',
            [docTypeValues.PURCHASE_ORDER]: 'JobScreen.PurchaseOrderTitle',
        };
        return typeTimeLineTitleMap[this.data.type] || 'Document';
    }
    getTypeString() {
        const docTypes = CONSTANTS.DOCUMENT.TYPES;
        if (docTypes[this.data.type]) {
            return docTypes[this.data.type];
        }
        console.log('Error! Document type not found!', this.data.type);
        return '';
    }
    isExpense() {
        return this.data.type === constants_1.DOCUMENT.TYPES_VALUES.EXPENSE || this.data.type === constants_1.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE;
    }
    isSupplierInvoice() {
        const { type } = this.data;
        const sharedDocType = CONSTANTS.DOCUMENT.TYPES_VALUES;
        return (type === sharedDocType.SUPPLIER_INVOICE || type === sharedDocType.SUPPLIER_INVOICE_CREDIT);
    }
    isExpOrSup() {
        return (this.isExpense() || this.isSupplierInvoice());
    }
    isExternalDocument() {
        return (!!this.data.external_company_id && !!this.data.external_document_id && this.data.external_clone);
    }
    isFinancial() {
        return CONSTANTS.DOCUMENT.IS_FINANCIAL[this.data.type];
    }
    async markForAccountingIntegration() {
        const companyIntegration = await this.getCompanyXeroIntegration();
        if (companyIntegration && companyIntegration.isRunning()) {
            this.data.sync_uuid = textUtils_1.default.generateUniqueId();
        }
    }
    async setConfirmed() {
        const job = await this.getJob();
        await this.markForAccountingIntegration();
        await job.updateTotals();
        this.data.confirmed = true;
    }
    async addJobItemGroupMedias(jobItemGroup) {
        const jobItems = await jobItemGroup.getAllJobItem();
        const medias = await bluebird_1.default.map(jobItems, item => item.getMediaGroup()).filter(Boolean);
        await this.addDocumentItems(medias);
    }
    async addDocumentItems(items, suffixMap) {
        await bluebird_1.default.each(items, async (item) => {
            await this.addDocumentItem({
                type: suffixMap ? item.getDocumentItemType(suffixMap[item.data.id]) : item.getDocumentItemType(),
                linked_id: item.data.id,
                document_id: this.data.id,
                sequence: (await this.getAllDocumentItem()).length + 1,
            });
            if (item instanceof (0, modelLookup_1.complexFindModel)('JobItemGroup')) {
                await item.refreshLayoutSettings();
                await this.addJobItemGroupMedias(item);
            }
        });
    }
    async generateCustomerContentData(L) {
        const site = await this.findSite();
        const customer = await this.getCustomer();
        const defaultSite = await this.getDefaultSite();
        return customer.getDocumentRenderData(L, {
            jobSite: site, defaultSite, documentType: this.data.type, plot: this.data.plot,
        });
    }
    async getCustomerContentData(L) {
        let customerData;
        const customerRenderData = await this.getCustomerRenderData();
        if (customerRenderData) {
            customerData = customerRenderData.getCustomerContent();
        }
        if (!customerData) {
            customerData = await this.generateCustomerContentData(L);
        }
        return customerData;
    }
    async getCompanyContentData(L) {
        let companyData;
        const companyRenderData = await this.getCompanyRenderData();
        if (companyRenderData) {
            companyData = companyRenderData.getCompanyContent();
        }
        if (!companyData) {
            companyData = await this.generateCompanyData(L);
        }
        return companyData;
    }
    async isContentUpdateMessageNeeded(L) {
        //
        // If document locked, then it is up to date
        //
        if (this.data.islocked
            || await this.isLocked()
            || this.data.vat_return_id
            || this.data.is_disbursement
            || (this.data.accounting_reference && this.data.accounting_reference !== '')) {
            return { customerUpToDate: true, companyUpToDate: true };
        }
        const companyUpToDate = await this.isCompanyContentUpToDate(L);
        const customerUpToDate = await this.isCustomerContentUpToDate(L);
        return { companyUpToDate, customerUpToDate };
    }
    static async isContentUpToDate(generateDataFn, getRenderDataFn, L) {
        const actualData = await generateDataFn(L);
        const renderedData = (await getRenderDataFn())?.data.data;
        if (!renderedData) {
            return true;
        }
        //
        // If the saved data has more fields than the actual data then we are most likely fine
        // as the early versions saved lot of unnecessary data (e.g. all logo fields) So we can remove these from the
        // diff before we compare
        //
        const diff = fast_json_patch_1.default
            .compare(renderedData, actualData)
            .filter(item => item.op !== 'remove')
            .filter(item => !(item.op === 'replace' && item.value === '' && Boolean((0, lodash_1.at)(renderedData, item.path.replace('/', '.').replace(/^\./, '')))));
        return diff.length === 0;
    }
    async isCompanyContentUpToDate(L) {
        return this.constructor.isContentUpToDate(this.generateCompanyData.bind(this), this.getCompanyRenderData.bind(this), L);
    }
    async isCustomerContentUpToDate(L) {
        return this.constructor.isContentUpToDate(this.generateCustomerContentData.bind(this), this.getCustomerRenderData.bind(this), L);
    }
    async resetCustomerContent() {
        await this.unsetCustomerRenderData();
        this.data.storage_url = '';
    }
    async resetCompanyContent() {
        await this.unsetCompanyRenderData();
        this.data.storage_url = '';
    }
    async generateCompanyData(L) {
        const company = await this.getCompany();
        return company.getDocumentRenderData(L, {});
    }
    async getDocumentRenderData(L, args) {
        const renderer = new renderData_1.default(L, this, args);
        return renderer.getDocumentTemplateData();
    }
    getStatusString(L) {
        const { promptId, defaultValue } = this.getStatusStringPrompt();
        return promptId !== '' ? L(promptId, defaultValue) : '';
    }
    minifyHtml(html, options = {}) {
        const defaultOptions = {
            caseSensitive: false,
            collapseBooleanAttributes: true,
            collapseWhitespace: true,
            conservativeCollapse: false,
            keepClosingSlash: false,
            maxLineLength: 0,
            minifyCSS: false,
            minifyJS: false,
            minifyURLs: false,
            processScripts: false,
            removeAttributeQuotes: true,
            removeCDATASectionsFromCDATA: true,
            removeComments: true,
            removeCommentsFromCDATA: true,
            removeEmptyAttributes: true,
            removeEmptyElements: false,
            removeIgnored: false,
            removeOptionalTags: false,
            removeRedundantAttributes: true,
            removeScriptTypeAttributes: false,
            removeStyleLinkTypeAttributes: false,
            useShortDoctype: true,
        };
        return (0, html_minifier_1.minify)(html, { ...defaultOptions, ...options });
    }
    async getOriginalPricedItem() {
        const items = (await this.getAllDocumentItem()).filter(item => item.data.linked_id && item.data.type === CONSTANTS.DOCUMENT.DOCUMENT_ITEMS.TYPES.JOB_ITEM_GROUP);
        const item = items[0];
        return item?.getLinkedItem();
    }
    async _recalculateJobItemGroups(jobItemGroupRecords = this.getJobItemGroups()) {
        await bluebird_1.default.each(jobItemGroupRecords, async (jobItemGroupRecord) => {
            await jobItemGroupRecord.recalculateAllLines();
        });
    }
    /**
     * tells if document has any jobItemGroup record
     */
    async hasJobItemGroups() {
        const jobItemGroups = await this.getJobItemGroups();
        return jobItemGroups.length > 0;
    }
    async hasMultipleJobItemGroups(type) {
        const jobItemGroups = await this.getJobItemGroups(type);
        return jobItemGroups.length > 1;
    }
    async updateDisplayTotals() {
        const jobItemGroups = await this.getJobItemGroups();
        const hasJobItemGroups = await this.hasJobItemGroups();
        const shouldDisplayTotals = Boolean(jobItemGroups.length > 1
            || (this.isFinancial() && !hasJobItemGroups));
        this.data.display_total = shouldDisplayTotals;
    }
    async updateDocumentTotals(jobItemGroupRecords) {
        await this._recalculateJobItemGroups(jobItemGroupRecords);
        await this.calculate();
        await this.updateSummary();
        await this.updateDisplayTotals();
    }
    async hasInvalidMediaDocumentItem(mediaDocumentItems) {
        const mediaItemWithJobItemGroup = await bluebird_1.default.filter(mediaDocumentItems, async (mediaDocumentItem) => {
            const mediaGroup = await mediaDocumentItem.getMedia();
            //
            // In some odd case there can be document item with the linked media deleted.
            // We should not crash in this case just move forward.
            //
            if (!mediaGroup) {
                return false;
            }
            const jobItem = await mediaGroup.getJobItem();
            const jobItemGroup = await jobItem?.getJobItemGroup();
            return Boolean(jobItemGroup);
        });
        return mediaItemWithJobItemGroup.length > 0;
    }
    /**
     * Document is auto created if
     *  - has only one jobItemGroup
     *  - has only one jobItemGroup which has only one Media
     *
     */
    async isAutoCreated() {
        let isAutoCreated = false;
        const documentItems = await this.getAllDocumentItem();
        const documentJobItemGroups = documentItems.filter(documentItem => documentItem.data.document_id === this.data.id && documentItem.data.type === constants_1.DOCUMENT.DOCUMENT_ITEMS.TYPES.JOB_ITEM_GROUP);
        const mediaDocumentItems = documentItems.filter(documentItem => documentItem.data.document_id === this.data.id && documentItem.data.type === constants_1.DOCUMENT.DOCUMENT_ITEMS.TYPES.MEDIA_GROUP);
        const allDocumentItemsLength = documentItems.length;
        const hasOnlyOneJobItem = documentJobItemGroups.length === 1;
        const hasOnlyJobItemsAndMedias = allDocumentItemsLength === documentJobItemGroups.length + mediaDocumentItems.length;
        const hasInvalidMediaItem = await this.hasInvalidMediaDocumentItem(mediaDocumentItems);
        let linkedJobItem;
        if (hasOnlyOneJobItem && hasOnlyJobItemsAndMedias) {
            linkedJobItem = await documentJobItemGroups[0].getLinkedItem();
            //
            // check if single job item has only medias
            //  - original_id not need to be defined, the most important to have only one jobItemGroup:
            //    quick document wizard currently supports only one jobItemGroup
            //
            if (!hasInvalidMediaItem && linkedJobItem) {
                isAutoCreated = true;
            }
        }
        return isAutoCreated;
    }
    async isEveryMediaUploaded() {
        const docItems = await this.getAllDocumentItem();
        return bluebird_1.default.reduce(docItems, async (result, item) => {
            const linkedMediaRecord = await item.getMedia();
            if (linkedMediaRecord) {
                return result ? await linkedMediaRecord.isEveryMediaUploaded() : false;
            }
            return result;
        }, true);
    }
    async setNoSync() {
        if (this.data.accounting_reference?.length > 0) {
            return;
        }
        const relatedChildDocuments = await this.getAllRelatedChildDocument();
        await bluebird_1.default.each(relatedChildDocuments, async (childDocumentToDocument) => {
            const childDocument = await childDocumentToDocument.getChild();
            await childDocument.setNoSync();
        });
        const paymentToInvoices = await this.getAllPaymentToInvoice();
        await bluebird_1.default.each(paymentToInvoices, async (paymentToInvoice) => {
            const payment = await paymentToInvoice.getPayment();
            await payment.setNoSync();
        });
        this.data.accounting_reference = constants_1.INTEGRATION.ACCOUNTING_REFERENCE_NO_SYNC;
    }
    async resetNoSync() {
        if (this.data.accounting_reference !== constants_1.INTEGRATION.ACCOUNTING_REFERENCE_NO_SYNC) {
            return;
        }
        const relatedChildDocuments = await this.getAllRelatedChildDocument();
        await bluebird_1.default.each(relatedChildDocuments, async (childDocumentToDocument) => {
            const childDocument = await childDocumentToDocument.getChild();
            childDocument.data.accounting_reference = null;
        });
        const paymentToInvoices = await this.getAllPaymentToInvoice();
        await bluebird_1.default.each(paymentToInvoices, async (paymentToInvoice) => {
            const payment = await paymentToInvoice.getPayment();
            payment.data.accounting_reference = null;
        });
        this.data.accounting_reference = null;
    }
    async isUnspecifiedCustomer() {
        const job = await this.getJob();
        const customer = await job.getCustomer();
        if (!customer) {
            return false;
        }
        return customer.data.is_nosupplier;
    }
}
Document.Entity = entity_1.default;
Document.modelProperties = modelProperties_1.default;
Document.MessageTypeSpecificDataCollectors = {};
Document.MessageTypeSpecificPermanentDataCollectors = {};
__decorate([
    (0, decorators_1.memoizeRunningPromiseByKey)(),
    (0, decorators_1.setMemoizeByInstance)()
], Document.prototype, "calculate", null);
exports.default = Document;
//# sourceMappingURL=../../../../src/models/document/index.js.map